import { ColorItemType } from "@mapmycustomers/shared/types/map/PinLegend";

const isDefaultColorOption = (color: ColorItemType) =>
  "fieldValue" in color &&
  color.fieldValue == null &&
  color.fieldValueMax == null &&
  !color.gradient;

export default isDefaultColorOption;
